<template>
  <div>
    <TableApp
      ref="tabela"
      titulo="Oportunidades"
      textoBtn="Nova oportunidade"
      api-url="/crm/oportunidades/lista"
      :fields="fields"
      fixedLayout
      @click.native.capture="handleTableClick"
    >
      <template slot="customRow" slot-scope="props">
        <router-link
          v-if="props.field === 'titulo'"
          class="text-dark-75 font-weight-bolder text-hover-primary crm-table-link"
          :to="{
            name: 'crmOportunidadeDetalhe',
            params: { id: props.rowData.id_crm_oportunidade },
          }"
        >
          {{ props.rowData.titulo }}
        </router-link>
      </template>
      <template #toolbar-actions>
        <button
          class="btn btn-dark font-weight-bolder font-size-sm"
          @click="abrirModal"
        >
          Nova oportunidade
        </button>
      </template>
    </TableApp>

    <b-modal
      id="crm-oportunidade-modal"
      title="Nova oportunidade"
      ok-title="Salvar"
      cancel-title="Cancelar"
      :ok-disabled="saving"
      :cancel-disabled="saving"
      @ok.prevent="salvar"
    >
      <b-form-group label="Título">
        <b-form-input v-model="form.titulo" />
      </b-form-group>
      <b-form-group label="Valor estimado">
        <money
          class="form-control"
          v-model="form.valor_estimado"
          v-bind="priceOptions"
        />
      </b-form-group>
      <b-form-group label="Previsão de fechamento">
        <b-form-input v-model="form.previsao_fechamento" type="date" />
      </b-form-group>
      <BuscaClienteContato
        v-model="vinculoSelecionado"
        label="Cliente ou contato"
        @criar-contato="criarContatoRapido"
      />
    </b-modal>
  </div>
</template>

<script>
import TableApp from "@/components/Table/Table2";
import BuscaClienteContato from "@/modules/CRM/components/BuscaClienteContato";
import crmService from "@/modules/CRM/services/crmService";
import { priceOptions } from "@/modules/Application";
import { Money } from "v-money";

export default {
  name: "crm-oportunidades",
  components: { BuscaClienteContato, Money, TableApp },
  data() {
    return {
      priceOptions,
      form: this.emptyForm(),
      saving: false,
      vinculoSelecionado: null,
      fields: [
        {
          label: "Título",
          field: "titulo",
          slot: true,
          filterOptions: { enabled: true },
        },
        {
          label: "Contato",
          field: "contato",
          filterOptions: { enabled: true },
        },
        { label: "Funil", field: "funil" },
        { label: "Etapa", field: "etapa" },
        { label: "Status", field: "status", filterOptions: { enabled: true } },
        { label: "Valor", field: "valor_estimado", type: "decimal" },
        { label: "Próxima ação", field: "proxima_atividade_em" },
      ],
    };
  },
  methods: {
    emptyForm() {
      return {
        titulo: "",
        valor_estimado: 0,
        previsao_fechamento: null,
        id_crm_contato: null,
        id_pessoa: null,
      };
    },
    abrirModal() {
      this.form = this.emptyForm();
      this.vinculoSelecionado = null;
      this.$bvModal.show("crm-oportunidade-modal");
    },
    async salvar() {
      if (!this.form.titulo) {
        this.$toast.error("Informe o título da oportunidade.");
        return;
      }

      if (!this.vinculoSelecionado) {
        this.$toast.error("Selecione um cliente ou contato.");
        return;
      }

      this.saving = true;

      try {
        const { data: oportunidadeCriada } = await crmService.criarOportunidade(
          {
            ...this.form,
            id_crm_contato: this.vinculoSelecionado.id_crm_contato,
            id_pessoa: this.vinculoSelecionado.id_pessoa,
          }
        );
        this.$toast.success("Oportunidade criada com sucesso.");
        this.$bvModal.hide("crm-oportunidade-modal");
        this.abrirOportunidadeCriada(oportunidadeCriada);
      } finally {
        this.saving = false;
      }
    },
    abrirOportunidadeCriada(oportunidade) {
      if (!oportunidade || !oportunidade.id_crm_oportunidade) {
        this.$refs.tabela.refresh();
        return;
      }

      this.$router
        .push({
          name: "crmOportunidadeDetalhe",
          params: { id: oportunidade.id_crm_oportunidade },
        })
        .catch(() => {});
    },
    async criarContatoRapido(payload) {
      const contatoPayload =
        typeof payload === "string"
          ? { nome: payload, origem_criacao_rapida: true }
          : { ...payload, origem_criacao_rapida: true };
      const { data } = await crmService.criarContato(contatoPayload);
      const contato = data.contato || data;
      this.vinculoSelecionado = {
        tipo: "contato",
        label: contato.nome,
        id_crm_contato: contato.id_crm_contato,
        id_pessoa: contato.id_pessoa || null,
        id_crm_oportunidade: null,
        raw: contato,
      };
      this.$toast.success("Contato criado e selecionado.");
    },
    handleTableClick() {},
  },
};
</script>

<style scoped>
.crm-table-link {
  display: inline-block;
  max-width: 100%;
  overflow-wrap: anywhere;
}
</style>
